import type { HubPersona, LinkedContact } from '../../models';
import { OtherKnownNetworkNames, WellKnownFolderNames } from '../../framework';
import { PersonType, WellKnownNetworkNames } from '../..';

/**
 * Returns true if persona is supported, false if not.
 * @param persona The persona to check
 */
export function isSupportedPersona(persona: HubPersona): boolean {
    if (
        persona.type === PersonType.PrivateDistributionList ||
        persona.type === PersonType.PublicDistributionList ||
        persona.type === PersonType.FavoritePerson ||
        persona.type === PersonType.FavoritePrivateDistributionList ||
        persona.type === PersonType.FavoriteUnifiedGroup ||
        persona.type === PersonType.Group ||
        persona.type === PersonType.GroupBasicData ||
        persona.type === PersonType.Generic
    ) {
        return true;
    }

    return (
        !persona.linkedContacts ||
        persona.linkedContacts.length === 0 ||
        persona.linkedContacts.some(contact => isSupportedContact(contact))
    );
}

/**
 * Return true if contact is supported, false if not.
 * Skype contacts are stale, but returned by various APIs. We need to filter these out until the Skype
 * feature has been repaired and we can start showing the Skype folder and contacts again.
 * We also want to filter out WindowsLive Contacts and network folder based contacts (3rd party social connectors)
 * Note: This will filter out all contacts from any folder named "WindowsLive Contacts", including manually created folders.
 * @param contact The contact to check
 */
export function isSupportedContact(contact: LinkedContact): boolean {
    return (
        !!contact &&
        contact.sourceDisplayName !== OtherKnownNetworkNames.SkypeForConsumer &&
        contact.sourceDisplayName !== OtherKnownNetworkNames.SkypeForBusiness &&
        contact.sourceFolderName !== WellKnownFolderNames.WindowsLiveContacts &&
        contact.sourceDisplayName !== WellKnownNetworkNames.Facebook &&
        contact.sourceDisplayName !== WellKnownNetworkNames.Google &&
        contact.sourceDisplayName !== WellKnownNetworkNames.LinkedIn
    );
}
